module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/ruler_left_pendant_12-2e7a03.svg";